import styled from 'styled-components';

import { fontSize, lightGray } from '../../styles/variables';

export const TagsWrapper = styled.div`
  background-color: #fff;
  display: inline-block;
  padding: 6px 0;
  color: #555;
  vertical-align: middle;
  line-height: 22px;
  cursor: text;
  border: 0;
  border-bottom: 1px solid #ccc;
  box-shadow: none;
  width: 100%;

  input[type='text'] {
    box-shadow: none;
    font-size: ${fontSize};
  }
  input::placeholder {
    font-size: ${fontSize};
  }
`;

export const Tag = styled.span`
  display: inline-block;
  color: ${lightGray};
  font-size: 1em;
  background-color: #eeeeee;
  font-weight: normal;
  margin-right: 3px;

  span[data-role='remove'] {
    margin-left: 8px;
    cursor: pointer;
  }
  span[data-role='remove']:after {
    content: 'x';
    padding: 0px 2px;
  }
  span[data-role='remove']:hover {
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.2),
      0 1px 2px rgba(0, 0, 0, 0.05);
  }
  span[data-role='remove']:hover:active {
    box-shadow: inset 0 3px 5px rgba(0, 0, 0, 0.125);
  }
`;

export const TagInput = styled.input`
  border: none;
  box-shadow: none;
  outline: none;
  background-color: transparent;
  padding: 0 6px;
  margin: 0;
  width: auto;
  max-width: inherit;

  &[type='text']:focus {
    border: none;
    box-shadow: none;
  }
`;
